<dashboardnav>
  <cradua-claimtype
  [claimtypes]="claimtypes$ | async"
  (claimtype)="onSubmitClaimType($event)"
  (deleteClaimTypeEvent)="onDeleteClaimType($event)"
  *ngIf="(isLoadingClaimType$ | async ) === false"
  >
</cradua-claimtype>

  <mrsoftapps-epims-reference-spinner
  *ngIf="(isLoadingClaimType$ | async) === true"
>
  </mrsoftapps-epims-reference-spinner>
  <!-- <pre>{{isLoading$ | async | json}}</pre> -->
</dashboardnav>
